export default {
  methods: {
    configureIconUrl({ uglyUrl, width, height }) {
      const obj = {
        '{w}': width,
        '{h}': height,
        '{f}': 'png',
      };
      return uglyUrl.replace(/{w}|{h}|{f}/g, matched => obj[matched]);
    },
  },
};
